import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import {
  Dialog,
  Slide,
  Box,
  Typography,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import { IoMdChatbubbles } from "react-icons/io";
import { FaRobot } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { MdOutlineRestartAlt } from "react-icons/md";
import axiosInstance from "../../../utils/axiosInstance";
import { answerApi, startApi } from "../../shared/ApiEndpoint";

// Slide transition for Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FloatingPopup = forwardRef(({ open, setOpen ,botId},ref) => { 

  const messagesEndRef = useRef(null);
  const [input, setInput] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [userName, setUserName] = useState(null);
  const [messages, setMessages] = useState([
    {
      sender: "",
      text: "",
    },
  ]);

  useEffect(() => {
  if (messagesEndRef.current) {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  }
}, [messages]);

  const handleToggle = () => setOpen((prev) => !prev);

  const handleSend = async (textFromButton) => {
    const text = textFromButton;
    if (!text) return;

    setMessages((prev) => [...prev, { sender: "user", text: text }]);
    setInput("");
    try {
      const res = await axiosInstance.post(answerApi, {
        session_id: sessionId,
        question_id: currentQuestion.question_id,
        answer: text,
        bot_id:botId
      });

      // if the bot asked for user's name, store it
      if (currentQuestion.question_id === "name_prompt") {
        setUserName(text);
      }

      setCurrentQuestion(res.data);
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: res.data.question },
      ]);
    //   setInput("");
      console.log(res?.data?.options);
    } catch (err) {
      if (err.response?.data?.detail === "End of conversation") {
        setMessages((prev) => [
          ...prev,
          { sender: "bot", text: "✅ End of conversation." },
        ]);
        setCurrentQuestion(null);
      } else if (err.response?.status === 422 || err.response?.status === 400) {
        // handleContinue();
      } else {
        console.error("Answer Error:", err);
      }
    }
  };

const startChat = useCallback(async () => {
  try {
    const res = await axiosInstance.post(startApi, { bot_id: botId }, { withCredentials: true });

    setSessionId(res.data.session_id);
    setCurrentQuestion(res.data);
    setMessages([{ sender: "bot", text: res.data.question }]);
  } catch (err) {
    console.error("Start Error:", err);
  }
}, [botId]);

   useImperativeHandle(ref, () => ({ startChat }), [startChat]);

  return (
    <>
      {/* Dialog Box */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleToggle}
        fullWidth
        maxWidth="xs"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "10px",
            margin: 0,
            position: "fixed",
            bottom: 20,
            right: 20,
            display: "flex",
            flexDirection: "column",
            height: 500, // fixed height for scroll area
          },
        }}
      >
        {/* Header */}
      <Box
  sx={{
    backgroundColor: "#216DB4",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: 2,
    py: 1.5,
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
  }}
>
  {/* Title */}
  <Typography variant="h6" display="flex" alignItems="center" gap={1}>
    <IoMdChatbubbles /> FloAssist
  </Typography>

  {/* Icons on the right side */}
  <Box display="flex" alignItems="center" gap={0.125}>
    <IconButton sx={{ color: "#fff" }} onClick={startChat}>
      <MdOutlineRestartAlt />
    </IconButton>
    <IconButton sx={{ color: "#fff" }} onClick={handleToggle}>
      <CloseIcon />
    </IconButton>
  </Box>
</Box>


        {/* Messages Scrollable Box */}
        <Box
          sx={{
            p: 2,
            overflowY: "auto",
            flexGrow: 1,
            backgroundColor: "#f9f9f9",
          }}
        >
          {messages.map((message, index) => (
            <Box
             ref={messagesEndRef}
              key={index}
              sx={{
                display: "flex",
                justifyContent:
                  message.sender === "bot" ? "flex-start" : "flex-end",
                mb: 1.5,
              }}
            >
              <Box>
                {message.sender === "bot" && (
                  <Box sx={{ fontSize: "0.8rem", color: "#216DB4", mb: 0.5 }}>
                    <FaRobot />
                  </Box>
                )}
                <Box
                  sx={{
                    backgroundColor:
                      message.sender === "bot" ? "#f1f1f1" : "#DCF8C6",
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    maxWidth: "250px",
                    wordBreak: "break-word",
                  }}
                >
                  <Typography variant="body2">{message.text}</Typography>
                </Box>

                {index === messages.length - 1 &&
                  message.sender === "bot" &&
                  currentQuestion?.options?.length > 0 && (
                    <Box
                      sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}
                    >
                      {currentQuestion.options.map((option, i) => (
                        <Button
                          key={i}
                          variant="outlined"
                          size="small"
                          onClick={() => handleSend(option)}
                          sx={{
                            textTransform: "none",
                            borderColor: "#216DB4",
                            borderRadius: "20px",
                            px: 2,
                            py: 0.5,
                            fontWeight: 500,
                            "&:hover": {
                              backgroundColor: "#1b5fa5",
                              borderColor: "#1b5fa5",
                            },
                          }}
                          style={{ backgroundColor: "#216DB4", color: "#fff" }}
                        >
                          {option}
                        </Button>
                      ))}
                    </Box>
                  )}
              </Box>
            </Box>
          ))}
        
        </Box>

        {/* Input Field */}

        {!currentQuestion?.options?.length && (
          <Box px={2} py={1}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend(input)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => handleSend(input)} color="primary">
                      <SendIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        )}
      </Dialog>
    </>
  );
});

export default FloatingPopup;
